import { NotifyStore } from 'api/ride';

export const getRegistrationStoreCounties = (stores: NotifyStore[]) =>
	Array.from(new Set(stores.map(store => store.county)));

export const getRegistrationStoreDistricts = (stores: NotifyStore[], county: string) =>
	Array.from(new Set(stores.filter(store => store.county === county).map(store => store.district)));

export const getRegistrationStores = (stores: NotifyStore[], county: string, district: string) =>
	stores.filter(store => store.county === county && store.district === district);

export const isRegistrationStoreValid = (stores: NotifyStore[], id: number | null) =>
	stores.length === 0 || (id !== null && stores.some(store => store.id === id));

export const getRegistrationStoreErrorKey = (
	county: string,
	district: string,
	id: number | null,
): string => {
	if (county.length === 0) return 'registrationStoreCounty';
	if (district.length === 0) return 'registrationStoreDistrict';
	if (id === null) return 'registrationStore';
	return 'registrationStore';
};

export const getRegistrationStoreRequestParams = (stores: NotifyStore[], id: number | null) =>
	stores.length > 0 && isRegistrationStoreValid(stores, id)
		? { registration_store_id: id as number }
		: {};
